import React from "react";
import SpecialistAssignmentBoard from "./SpecialistAssignmentBoard";
import FlowEngineGlobalGate from "../specialist-flow-engine/FlowEngineGlobalGate";

const SpecialistEditorSelectionScreen = () => {
  return (
    <FlowEngineGlobalGate>
      <SpecialistAssignmentBoard
        roleKey="editor"
        titleKey="specialist.selection.editor.title"
        defaultTitle="Bandeja del Editor"
      />
    </FlowEngineGlobalGate>
  );
};

export default SpecialistEditorSelectionScreen;



